import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setdeleteAssignment, setloading, seterror, resetdeleteAssignment
} from "../reducers/deleteAssignmentReducer";

const deleteAssignmentById = (id: any, token: any) => async (dispatch: Dispatch) => {
    dispatch(setloading(true));
    try {
        const result = await api
            .delete(
                `/assignments/delete-assignment/${id}/`,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Token ${token}`
                    },
                }
            )

        if (result) {
            dispatch(setloading(false));
            if (result.data?.status === 200) {
                dispatch(setdeleteAssignment(result?.data));
            }
            else {
                dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    }
    catch (error: any) {
        dispatch(seterror(error.response.data.message));
    }
}

export { deleteAssignmentById, resetdeleteAssignment }

